{
  "version": 1,
  "asset_id": "20ab92c1-471b-4ddb-a1ad-3a19afb338a5",
  "project_id": "5d92abc2-3725-40e6-9101-11b832091b05",
  "url": "/__l5e/assets-v1/20ab92c1-471b-4ddb-a1ad-3a19afb338a5/cableplm-logo.svg",
  "r2_key": "a/v1/5d92abc2-3725-40e6-9101-11b832091b05/20ab92c1-471b-4ddb-a1ad-3a19afb338a5/cableplm-logo.svg",
  "original_filename": "cableplm-logo.svg",
  "size": 5135,
  "content_type": "image/svg+xml",
  "created_at": "2026-10-29T06:52:41Z"
}
